/** @jsx jsx */
import {jsx, css} from '@emotion/react'
import {createMarkup} from '../../../util/datoCmsDataFactory'

import LogoButton from './logo-button'
import FastCompanyLogo from '../../../images/fast-company-logo.svg'
import {colors} from '../../../constants'

const Bottom = ({linksSection, onCtaClick}) => {
    return (
        <section
            css={css`
                margin: 4rem auto;
            `}
        >
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                `}
            >
                <LogoButton onCtaClick={onCtaClick} />
                <div
                    css={css`
                        text-align: center;
                        margin: 2rem 0;
                        p {
                            margin-bottom: 1rem;
                            font-size: 1.1rem;
                            @media (max-width: 600px) {
                                font-size: 1rem;
                            }
                        }
                    `}
                >
                    <p>“This alternative search engine is basically Google without the privacy headaches.”</p>
                    <FastCompanyLogo
                        css={css`
                            width: 150px;
                        `}
                    />
                </div>
            </div>
            {linksSection && (
                <div
                    dangerouslySetInnerHTML={createMarkup(linksSection)}
                    css={css`
                        ul {
                            padding: 0;
                            list-style-type: none;
                        }
                        a {
                            margin-left: 0.25rem;
                            color: ${colors.brandBlue};
                            word-wrap: break-word;
                        }
                    `}
                />
            )}
        </section>
    )
}

export default Bottom
